module.exports = __webpack_public_path__ + "img/09.791e90bd.png";